module.exports = __webpack_public_path__ + "img/product-8.20445a99.jpg";